module.exports = __webpack_public_path__ + "img/chevron-filter.3b0eba46.svg";